import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/zh-cn/services/pharmacovigilance/comprehensive-medical-information-services")({
  head: () => buildRouteHead("/zh-cn/services/pharmacovigilance/comprehensive-medical-information-services"),
  component: PVOffering,
});

